import React from 'react';
import IDHelpers from '../../../../../core/helpers/IDHelper';
import CardCategory from '@/presentation/reusables/CardCategory';
import Container from './style';
import { Category, ListCategoryProps } from './type';

const ListCategory = ({
  courseSections,
  handleSelectCategory,
  testId
}: ListCategoryProps) => (
  <Container data-testid={testId}>
    {courseSections &&
      courseSections.length > 0 &&
      courseSections.map((category: Category) => (
        <CardCategory
          key={IDHelpers.generateID()}
          testId={category.test}
          icon={category.icon}
          onClick={() => handleSelectCategory(category.url)}
          description={category.description}
          title={category.title}
        />
      ))}
  </Container>
);

export default ListCategory;
